module.exports = __webpack_public_path__ + "media/images/expandArrows-d8223a3a.png";